import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useApp } from '../context/AppContext';
import { fmtMoney } from '../lib/format';

// What QPS Hub has earned in platform fees: the hub's share of every online
// payment a customer made to a vendor, by month. Only payments that have
// cleared count; a bank transfer still in flight is not money yet.
export default function PlatformRevenue() {
  const { authHeaders } = useApp();
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get('/api/pay/revenue/summary', authHeaders()).then(r => setData(r.data)).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!data) return null;
  return (
    <div className="card" style={{ marginBottom: 14 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 8 }}>
        <div style={{ fontSize: 15, fontWeight: 700 }}>QPS Hub platform fees</div>
        <div style={{ fontSize: 18, fontWeight: 800, color: 'var(--green)' }}>{fmtMoney(data.total)}</div>
      </div>
      {!data.configured && (
        <div style={{ fontSize: 12.5, color: 'var(--muted)', marginTop: 6 }}>
          Online payments are off. Add the Stripe keys in Render to switch them on (see DEPLOY.md).
        </div>
      )}
      {data.configured && data.months.length === 0 && (
        <div style={{ fontSize: 12.5, color: 'var(--muted)', marginTop: 6 }}>No online vendor payments yet.</div>
      )}
      {data.months.map(m => (
        <div key={m.month} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, padding: '6px 0', borderTop: '1px solid var(--border)', marginTop: 6 }}>
          <span>{new Date(`${m.month}-15`).toLocaleDateString('en-US', { month: 'long', year: 'numeric' })} · {m.payments} payment{m.payments === 1 ? '' : 's'} · {fmtMoney(m.collected)} collected</span>
          <strong>{fmtMoney(m.platformFee)}</strong>
        </div>
      ))}
    </div>
  );
}
